export default __webpack_public_path__ + "459aa69512af15820b797952a55c77b9.png";